<template>
  <v-card class="pa-2 px-4">
    <div class="pb-2">Blog Posts</div>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
export default {
  name: "blogPosts",
};
</script>

<style>
</style>